import * as React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { IsaAllowanceOverviewAction } from "../Action/IsaAllowanceOverviewAction";
import { IsaAllowanceOverviewChart } from "./IsaAllowanceOverviewChart";

interface IIsaAllowanceOverviewProps extends React.Props<IsaAllowanceOverview> {
    headaccount: ClientAccount;
    bedProductAmount?: number;
    updateRemainingAllowance?: (amount: number, startYear: Date, endYear: Date)  => void;
}

interface IIsaAllowanceOverviewState {
    used: Money;
    expected: Money;
    remaining: Money;
    taxYearStartDate: Date;
    taxYearEndDate: Date;
    clAccountId: string;
}

export class IsaAllowanceOverview extends FormComponent<IIsaAllowanceOverviewProps, IIsaAllowanceOverviewState> {
    constructor(props: any) {
        super(props);
        this.state = {
            used: null,
            expected: null,
            remaining: null,
            taxYearStartDate: new Date(),
            taxYearEndDate: new Date(),
            clAccountId: null,
        };
    }
    public componentDidMount() {
        this.getData();
    }
    private getData() {
        IsaAllowanceOverviewAction.getIsaAllowance(this.props.headaccount?.HierarchyId, (isaAllowance: any) => {            
            this.setState({
                used: isaAllowance?.Used,
                expected: isaAllowance?.Expected,
                remaining: isaAllowance?.Remaining,
                taxYearStartDate: isaAllowance?.TaxYear?.StartDate,
                taxYearEndDate: isaAllowance?.TaxYear?.EndDate,
                clAccountId: this.props.headaccount?.HeadClAccountId,
            });
            this.props?.updateRemainingAllowance(isaAllowance?.Remaining?.Amount,isaAllowance?.TaxYear?.StartDate,isaAllowance?.TaxYear?.EndDate);
        });
    }

    public render(): JSX.Element {
        const { used, expected, remaining, taxYearStartDate, taxYearEndDate, clAccountId } = this.state;
        const startYear = JsonDateParser.getFormatDate(taxYearStartDate, "yyyy");
        const endYear = JsonDateParser.getFormatDate(taxYearEndDate, "yyyy");
        const today = JsonDateParser.getFormatDateString(new Date(), "dd-MM-yyyy", true, true);
        const usedValueUpdated: Money = {
            Amount: (this.state.used?.Amount ?? 0) + (this.props.bedProductAmount ?? 0),
            Currency: this.state.used?.Currency
          };
          
          const remainingValueUpdated: Money = {
            Amount: (this.state.remaining?.Amount ?? 0) - (this.props.bedProductAmount ?? 0),
            Currency: this.state.remaining?.Currency
          };
          

        return (
            <>
                <h2 className="mb-22">ISA allowance</h2>
                <h3>
                    Tax year {startYear}/{endYear}
                </h3>
                <div className="panel-subtle">
                    <IsaAllowanceOverviewChart used={usedValueUpdated} expected={expected} remaining={remainingValueUpdated} />
                    {checkPermission(UserClaim.AdviserPortalDluIsaSubscriptionsCanView) && (
                        <div className="mt-30">
                            <a
                                href={
                                    "/clients/orders/isasubscriptions.aspx?claccountid=" +
                                    clAccountId +
                                    "&asatdate=" +
                                    today +
                                    "&todate=" +
                                    today
                                }
                                target="_blank"
                                className="hyperlink"
                            >
                                View all ISA subscriptions
                            </a>
                        </div>
                    )}
                </div>

                <hr className="mt-50 mb-50" />
            </>
        );
    }
}